import SpotPageContainer from './SpotPageContainer';

export default SpotPageContainer;
